import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { styled } from "@mui/material/styles";
import { FaRegArrowAltCircleDown, FaRegArrowAltCircleUp } from "react-icons/fa";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import { Link, useNavigate } from "react-router-dom";
import { SearchOutlined } from "@ant-design/icons";
import Checkbox from "@mui/material/Checkbox";
import { MdEdit, MdDelete } from "react-icons/md";
import { Input, Modal, message } from "antd";
import {
  categoryDelete,
  categoryStatusChange,
} from "../../../redux/category/CategorySlice";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    backgroundColor: "#006fa9",
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&td, &th": {
    border: 0,
  },
}));

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const ListCategory = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { allCategorys } = useSelector((store) => store.category);
  const [messageApi, contextHolder] = message.useMessage();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortOrder, setSortOrder] = useState("asc");
  const [filter_data, setfilter_data] = useState([]);
  const [search, setSearch] = useState("");
  const [selectData, setSelectData] = useState("");
  const [modal, setModal] = useState(false);
  let menubar = true;

  const statusChange = async (e, data) => {
    e.preventDefault();
    const value = e.target.checked;
    const formData = {
      slug: data.slugUrl,
      status: value,
    };
    const updateprod = await dispatch(categoryStatusChange(formData));
    if (updateprod.payload.success) {
      if (updateprod.payload.category.status === true) {
        messageApi.open({
          type: "success",
          content: "Publish Status Set To True",
        });
      } else {
        messageApi.open({
          type: "success",
          content: "Publish Status Set To False",
        });
      }
    } else {
      messageApi.open({
        type: "error",
        content: "Something went wrong",
      });
    }
  };

  const deleteClick = async (e) => {
    const id = selectData.slugUrl;
    const deletclick = await dispatch(categoryDelete(id));
    if (deletclick.payload.success) {
      setModal(false);
      messageApi.open({
        type: "success",
        content: "Category deleted  successfully",
      });
    }
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const toggleSortOrder = () => {
    setSortOrder(sortOrder === "asc" ? "desc" : "asc");
  };

  useEffect(() => {
    let sortedData = [...allCategorys];

    if (search !== "") {
      sortedData = sortedData.filter((transaction) => {
        return transaction.nameInTelugu.toLowerCase().match(search.toLowerCase());
      });
    }
    if (sortOrder === "asc") {
      sortedData = sortedData.sort((a, b) => a.priority - b.priority);
    } else {
      sortedData = sortedData.sort((a, b) => b.priority - a.priority);
    }

    setfilter_data(sortedData);
  }, [sortOrder, allCategorys, search]);

  return (
    <>
      {contextHolder}

      <Modal
        open={modal}
        title=" "
        onOk={(e) => deleteClick(e)}
        onCancel={() => setModal(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <>
            <CancelBtn />
            <OkBtn />
          </>
        )}
      >
        <p> Do you want to Delete {selectData.name} </p>
      </Modal>

      <div className="main_fragnent_container p-2">
        <div className="profile_container_header">
          <div className="profile_co_header_left">
            <span>All Categories</span>
            <span
              style={{
                visibility: "hidden",
              }}
            >
              Student
            </span>
          </div>
          <div className="profile_co_header_right"></div>
        </div>
        <div className="transaction_header">
          {/* <Input
            placeholder="Name Search"
            value={search}
            onChange={(e) => setSearch(e.target.value.toUpperCase())}
            style={{
              width: "50vh",
            }}
            suffix={
              <SearchOutlined
                style={{
                  fontSize: 16,
                  color: "#1677ff",
                }}
              />
            }
          /> */}
          <TablePagination
            component="div"
            count={0}
            page={0}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[10, 25, 100]}
            labelRowsPerPage="Rows:"
            labelDisplayedRows={() => null}
            SelectProps={{
              inputProps: { "aria-label": "rows" },
              native: true,
            }}
            ActionsComponent={() => null}
          />
          <StyledTableCell
            align="left"
            sx={{ border: "none", cursor: "pointer" }}
            onClick={toggleSortOrder}
          >
            Priority {" :"}{" "}
            {sortOrder === "asc" ? (
              <FaRegArrowAltCircleUp />
            ) : (
              <FaRegArrowAltCircleDown />
            )}
          </StyledTableCell>
        </div>
        <div className="letter_content">
          <Paper sx={{ width: "100%", overflow: "hidden" }}>
            <TableContainer component={Paper} className="customScrollbar">
              <Table
                sx={{ minWidth: 700, border: "none" }}
                aria-label="customized table"
              >
                <TableHead>
                  <TableRow>
                    <StyledTableCell align="left" sx={{ border: "none" }}>
                      No
                    </StyledTableCell>
                    <StyledTableCell align="left" sx={{ border: "none" }}>
                      Name
                    </StyledTableCell>
                    <StyledTableCell align="left" sx={{ border: "none" }}>
                      Priority
                    </StyledTableCell>
                    <StyledTableCell align="left" sx={{ border: "none" }}>
                      Publish Status
                    </StyledTableCell>
                    <StyledTableCell align="center" sx={{ border: "none" }}>
                      ACTION
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {filter_data
                    .slice(page * rowsPerPage, (page + 1) * rowsPerPage)
                    .map((data, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell
                          component="th"
                          scope="row"
                          sx={{ border: "none" }}
                        >
                          {index + 1}
                        </StyledTableCell>
                        <StyledTableCell
                          width={(menubar = true ? 500 : 650)}
                          align="left"
                          sx={{ border: "none" }}
                        >
                          <span
                            style={{
                              cursor: "pointer",
                              color: "blue",
                              
                            }}
                            onClick={() => {
                              navigate(
                                `/admin/update-category/${data.slugUrl}`
                              );
                            }}
                          >
                           {data.nameInEnglish} ({data.nameInTelugu})
                          </span>
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          width={90}
                          sx={{ border: "none" }}
                        >
                          {data.priority}
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          width={160}
                          sx={{ border: "none" }}
                        >
                          <Checkbox
                            {...label}
                            value={data.status}
                            checked={data.status === true}
                            onChange={(e) => {
                              statusChange(e, data);
                            }}
                          />
                        </StyledTableCell>
                        <StyledTableCell
                          align="center"
                          width={140}
                          sx={{ border: "none" }}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                              flexDirection: "row",
                              gap: "1vh",
                            }}
                          >
                            <Link to={`/admin/update-category/${data.slugUrl}`}>
                              <div className="approve_box">
                                <MdEdit />
                              </div>
                            </Link>
                            <div
                              className="regect_box"
                              onClick={() => {
                                setSelectData(data);
                                setModal(true);
                              }}
                            >
                              <MdDelete />
                            </div>
                          </div>
                        </StyledTableCell>
                      </StyledTableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>

            <TablePagination
              rowsPerPageOptions={[10, 25, 100]}
              component="div"
              count={filter_data.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
            />
          </Paper>
        </div>
      </div>
    </>
  );
};

export default ListCategory;
